import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {UploadFile} from '../../../upload-file';
import {Request} from '../../../models/request';
import {Configuration} from '../../../models/configuration';
import {MetadataListComponent} from "../metadata-list/metadata-list.component";

@Component({
  selector: 'app-file-component',
  templateUrl: './file-component.component.html',
  styleUrls: ['./file-component.component.css']
})
export class FileComponentComponent implements OnInit, OnChanges {
  @Input()
  uploadedFile: UploadFile;
  @Output()
  uploadedFileChange = new EventEmitter<UploadFile>();
  previewSrc: any;
  @Output()
  deleteFile: EventEmitter<number> = new EventEmitter<number>();
  @Input()
  request: Request;
  @Input()
  infoFieldsTemplate: any[];
  @Input()
  valueOptions: any[];
  @Input()
  selectizeConfigs: any[];
  infoFields;
  @Output()
  applyMetadata = new EventEmitter<Configuration>();
  @Input()
  metadataLanguages;
  @Input()
  defaultLanguage;
  @Input()
  urlPresetsMap;
  @Input()
  hideDisabledFields;
  @Output()
  appliedInfofield = new EventEmitter<any>();
  @Input()
  dateFormat: string;
  @ViewChild(MetadataListComponent, {static: false})
  metadataList: MetadataListComponent;
  @Input()
  index;

  constructor() { }

  ngOnInit() {
    this.infoFields = JSON.parse(JSON.stringify(this.infoFieldsTemplate));
  }

  ngOnChanges(changes: SimpleChanges) {
    this.generatePreview(this.uploadedFile.file);
  }

  generatePreview(file: File) {
    const mimeType = file.type;
    if(mimeType) {
      if (mimeType.match(/image\/*/) != null) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
          this.previewSrc = reader.result;
        };
      }
    }
  }

  applyMetadataForAllAssets() {
    this.metadataList.applyAllInfofields();
  }

  delete() {
    this.deleteFile.emit();
  }

  applyInfofield($event: any) {
    this.appliedInfofield.emit($event);
  }
}
